import React from 'react'
import Svg from './../Svg'

// I24NewsPlusIcon :: Props -> React.Component
export default ({
  width = 50,
  height = 25,
  'aria-label': ariaLabel,
  className = '',
}) =>
  <Svg
    className={ className }
    width={ width }
    height={ height }
    viewBox="0 0 1920 1080"
    aria-label={ ariaLabel }
  >
    <defs>
      <linearGradient
        id="New_Gradient_Swatch_2"
        x1={1643.97}
        x2={1741.05}
        y1={1239.77}
        y2={689.22}
        data-name="New Gradient Swatch 2"
        gradientTransform="rotate(-2.96 -3809.709 -98.43) skewX(-2.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#3084f6" />
        <stop offset={1} stopColor="#26d076" />
      </linearGradient>
      <linearGradient
        id="linear-gradient"
        x1={1160.5}
        x2={1496.15}
        y1={646.43}
        y2={928.07}
        gradientTransform="rotate(-2.96 -3809.709 -98.43) skewX(-2.95)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.67} />
        <stop offset={0.68} stopColor="#0f0f0f" />
        <stop offset={0.73} stopColor="#4d4d4d" />
        <stop offset={0.78} stopColor="#838383" />
        <stop offset={0.83} stopColor="#b0b0b0" />
        <stop offset={0.88} stopColor="#d2d2d2" />
        <stop offset={0.93} stopColor="#eaeaea" />
        <stop offset={0.97} stopColor="#f9f9f9" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        xlinkHref="#New_Gradient_Swatch_2"
        id="New_Gradient_Swatch_21"
        x1={1476}
        x2={1573.08}
        y1={1210.15}
        y2={659.6}
        data-name="New Gradient Swatch 2"
      />
      <linearGradient
        xlinkHref="#New_Gradient_Swatch_2"
        id="New_Gradient_Swatch_22"
        x1={462.63}
        x2={462.63}
        y1={1182.19}
        y2={679.27}
        data-name="New Gradient Swatch 2"
      />
      <linearGradient
        xlinkHref="#New_Gradient_Swatch_2"
        id="New_Gradient_Swatch_23"
        x1={645.73}
        x2={645.73}
        y1={1182.19}
        y2={679.27}
        data-name="New Gradient Swatch 2"
      />
      <linearGradient
        xlinkHref="#New_Gradient_Swatch_2"
        id="New_Gradient_Swatch_24"
        x1={876.14}
        x2={876.14}
        y1={1182.19}
        y2={679.27}
        data-name="New Gradient Swatch 2"
      />
      <linearGradient
        xlinkHref="#New_Gradient_Swatch_2"
        id="New_Gradient_Swatch_25"
        x1={1064.95}
        x2={1064.95}
        y1={1182.19}
        y2={679.27}
        data-name="New Gradient Swatch 2"
      />
      <style>{'.st7{fill:#f0f0ff}'}</style>
      <mask
        id="mask"
        width={735.3}
        height={533.15}
        x={1154.28}
        y={403.11}
        maskUnits="userSpaceOnUse"
      >
        <path
          d="m1855.96 743.38 33.62-174.69-701.69 36.27-33.61 174.69 701.68-36.27z"
          style={{
            fill: 'url(#linear-gradient)',
          }}
        />
      </mask>
    </defs>
    <path
      d="m1657.42 869.31 22.46-116.78h.02v-.05l176.05-9.1 33.62-174.68-176.09 9.1 33.58-174.68-176.13 9.1-33.59 174.63h-.02v.05l-33.58 174.68-33.58 174.68 116.51-6.02c34.2-1.77 63.65-27.23 70.75-60.94Z"
      style={{
        fill: 'url(#New_Gradient_Swatch_2)',
      }}
    />
    <g
      style={{
        mask: 'url(#mask)',
      }}
    >
      <path
        d="m1657.42 869.31 22.46-116.78h.02v-.05l176.05-9.1 33.62-174.68-176.09 9.1 33.58-174.68-176.13 9.1-33.59 174.63h-.02v.05l-349.43 18.06-33.62 174.68 349.47-18.06-33.58 174.68 116.51-6.02c34.2-1.77 63.65-27.23 70.75-60.94Z"
        style={{
          fill: 'url(#New_Gradient_Swatch_21)',
        }}
      />
    </g>
    <path
      d="m493.86 970.38-50.12-83.22-41.99 2.17-31.55 166.2 44.53-2.31 17.31-89.96 52.04 86.38 39.43-2.04 31.56-166.19-44.53 2.3-16.68 86.67z"
      style={{
        fill: 'url(#New_Gradient_Swatch_22)',
      }}
    />
    <path
      d="m564.66 1045.47 131.75-6.81 7.44-40.66-87.21 4.51 5-26.73 77.93-4.03 6.9-36.03-77.93 4.03 4.78-22.11 86.05-4.45 7.44-40.66-130.59 6.75-31.56 166.19z"
      style={{
        fill: 'url(#New_Gradient_Swatch_23)',
      }}
    />
    <path
      d="m955.59 860.7-46.56 96.58-12.97-93.5-38.73 2-49.66 96.74-10.04-93.65-47.55 2.46 22.49 163.4 39.2-2.03 50.64-96.09 14.54 92.72 39.2-2.02 86.06-169.02-46.62 2.41z"
      style={{
        fill: 'url(#New_Gradient_Swatch_24)',
      }}
    />
    <path
      d="M1055.92 901.67c1.13-5.86 7.36-10.82 18.27-11.38 14.38-.74 29.54 4.04 42.35 13.82l28.68-33.26c-14.88-13.38-35.01-19.76-62.61-18.33-38.97 2.01-67.1 25.27-72.96 55.72l-.09.47c-6.49 33.73 18.29 42.19 51.32 48.37 21.04 4.01 25.66 7.49 24.35 14.28l-.09.47c-1.35 7.03-8.66 11.58-20.72 12.2-18.79.97-35.34-4.9-48.87-16.96l-30.87 31.52c16.48 17.01 42.09 24.73 70.85 23.24 39.43-2.04 69.47-23.3 75.92-56.81l.09-.47c5.91-30.69-14.94-41.67-50.71-47.94-21.51-3.99-26.44-6.98-25-14.48l.09-.47Z"
      style={{
        fill: 'url(#New_Gradient_Swatch_25)',
      }}
    />
    <path
      d="m1824.57 0-48.76 2.52-127.32 6.58-48.76 2.52-521.43 599.01-483.92 25.01c17-62.96 68.42-114.4 144.34-118.32l227.61-11.76c126.17-6.52 228.81-115.85 228.81-242.42S1092.5 37.85 966.33 44.37L524.76 67.19l-33.62 174.68 475.18-24.56c30.28-1.57 55.86 24.08 55.86 54.76s-25.58 58.97-55.86 60.54l-227.61 11.76c-158.43 8.19-291.69 129.34-324.07 296.3l-25.5 136.12C371.06 797.3 281.82 896.17 250.51 886.9c-14.46-4.28-13.07-27.62-11.74-37.78l101.67-528.51-191.54 9.9S55.38 816.37 54.38 821.55c-18.79 93.48-35.15 179.69-14.01 222.6 67.22 136.45 296.07-155.71 348.09-224.92l765.82-39.59L1824.57 0Z"
      className="st7"
    />
    <path
      d="m388.05 74.13-73.01 3.77c-68.83 3.56-128.01 55.24-141.15 123.48l-11 57 191.54-9.9 33.62-174.36Z"
      className="st7"
    />
  </Svg>
